(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buyer-guide-goalie"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SELECTOR = '[data-goalie-guide-root]';

  function normalizeHandle(value = '') {
    return value
      .toString()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function isToggleInput(field) {
    return field.type === 'checkbox' || field.type === 'radio';
  }

  function clearInput(field) {
    if (isToggleInput(field)) {
      field.checked = false;
    } else {
      field.value = '';
    }
  }

  function initGoalieGuide(section) {
    if (!section || section.dataset.goalieGuideInitialized === 'true') return;
    section.dataset.goalieGuideInitialized = 'true';

    /* ==========================================================
       MAIN ACCORDION
       ========================================================== */

    const mainToggle = section.querySelector('.goalie-guide__main-toggle');
    const mainContent = section.querySelector('.goalie-guide__content');

    if (mainToggle && mainContent) {
      const startsOpen = section.dataset.openByDefault === 'true';

      section.classList.toggle('is-collapsed', !startsOpen);
      mainToggle.setAttribute('aria-expanded', String(startsOpen));
      mainContent.hidden = !startsOpen;

      mainToggle.addEventListener('click', () => {
        const nextOpen = mainToggle.getAttribute('aria-expanded') !== 'true';
        mainToggle.setAttribute('aria-expanded', String(nextOpen));
        mainContent.hidden = !nextOpen;
        section.classList.toggle('is-collapsed', !nextOpen);
      });
    }

    /* ==========================================================
       MODULE ACCORDIONS
       ========================================================== */

    const closeOtherCards = section.dataset.closeOtherCards === 'true';
    const cards = Array.from(section.querySelectorAll('.goalie-guide-card'));
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    function isFieldAvailable(field) {
      if (field.disabled) return false;
      if (field.closest('[data-spec-field][hidden]')) return false;
      if (isToggleInput(field) && !field.checked) return false;
      return Boolean(field.value);
    }

    function cardHasSelections(card) {
      return Array.from(card.querySelectorAll('[data-filter-param]')).some(isFieldAvailable);
    }

    function setCardOpen(card, open) {
      const button = card.querySelector('.goalie-guide-card__toggle');
      const panel = card.querySelector('.goalie-guide-card__panel');

      card.classList.toggle('is-open', open);
      if (button) button.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
    }

    function closeCardsExcept(activeCard) {
      if (!closeOtherCards) return;

      cards.forEach((otherCard) => {
        if (otherCard === activeCard) return;
        if (desktopQuery.matches && cardHasSelections(otherCard)) return;
        setCardOpen(otherCard, false);
      });
    }

    cards.forEach((card) => {
      const button = card.querySelector('.goalie-guide-card__toggle');
      const panel = card.querySelector('.goalie-guide-card__panel');
      if (!button || !panel) return;

      button.addEventListener('click', () => {
        const isOpen = card.classList.contains('is-open');
        if (!isOpen) closeCardsExcept(card);
        setCardOpen(card, !isOpen);
      });
    });

    /* ==========================================================
       FILTER ELEMENTS + SETTINGS
       ========================================================== */

    const filterForm = section.querySelector('[data-goalie-guide-filter-form]');
    if (!filterForm) return;

    const clearAllButton = section.querySelector('[data-goalie-guide-clear-all]');
    const viewResultsButton = section.querySelector('[data-goalie-guide-view-results]');
    const activeChips = section.querySelector('[data-active-filter-chips]');
    const activeChipList = section.querySelector('[data-active-filter-chip-list]');

    const updatingFiltersText = section.dataset.updatingFiltersText || 'Updating matching goalie sticks…';
    const updatedFiltersText = section.dataset.updatedFiltersText || 'Matching goalie sticks updated.';
    const filterUpdateErrorText = section.dataset.filterUpdateErrorText || 'Matching goalie sticks could not be refreshed. Please try again.';
    const refreshDelay = Number(section.dataset.filterRefreshDelay) || 0;
    const showInStockOnly = section.dataset.showInStockOnly === 'true';

    const specParams = (section.dataset.specParams || '')
      .split('|')
      .map((param) => param.trim())
      .filter(Boolean);

    /*
      Params this guide owns. Anything else in the URL (for example a
      native Shark filter the guide doesn't render) is preserved.
    */
    const controlledParams = new Set([
      'filter.v.availability',
      'filter.p.product_type',
      'filter.v.price.gte',
      'filter.v.price.lte',
      ...specParams
    ]);

    let refreshController = null;
    let refreshTimer = null;
    let successMessageTimer = null;
    let isRefreshing = false;

    /* ==========================================================
       STICK TYPE
       ========================================================== */

    function getProductTypeOptions() {
      return Array.from(section.querySelectorAll('[data-product-type-option]'));
    }

    function restoreProductTypeFromUrl(search = window.location.search) {
      const options = getProductTypeOptions();
      if (options.length === 0) return;

      const activeHandles = new URLSearchParams(search)
        .getAll('filter.p.product_type')
        .flatMap((value) => value.split(','))
        .map(normalizeHandle)
        .filter(Boolean);

      const matchingOption = options.find((option) => {
        const optionHandles = [
          ...option.value.split(','),
          ...(option.dataset.nativeFilterValues || '').split('|||')
        ]
          .map(normalizeHandle)
          .filter(Boolean);

        return activeHandles.length > 0 && activeHandles.every((handle) => optionHandles.includes(handle));
      });

      const fallbackOption = options.find((option) => option.value === '');

      options.forEach((option) => { option.checked = false; });

      if (matchingOption) {
        matchingOption.checked = true;
      } else if (fallbackOption) {
        fallbackOption.checked = true;
      }
    }

    function restoreFieldsFromUrl(search = window.location.search) {
      const params = new URLSearchParams(search);

      restoreProductTypeFromUrl(search);

      filterForm
        .querySelectorAll('[data-filter-param]:not([data-product-type-option])')
        .forEach((field) => {
          const param = field.getAttribute('data-filter-param');
          if (!param) return;

          const value = params.get(param) || '';

          if (field.matches('select')) {
            const exists = Array.from(field.options).some((option) => option.value === value);
            field.value = exists ? value : '';
          } else if (isToggleInput(field)) {
            field.checked = params.getAll(param).includes(field.value);
          } else {
            field.value = value;
          }
        });
    }

    function openSpecsCard() {
      const specsCard = section.querySelector('.goalie-guide-card--specs-filter-module');
      if (!specsCard) return;
      closeCardsExcept(specsCard);
      setCardOpen(specsCard, true);
    }

    function clearSpecSelections() {
      section
        .querySelectorAll('[data-goalie-guide-specs-grid] [data-filter-param]')
        .forEach(clearInput);
    }

    /* ==========================================================
       ACTIVE FIELDS + URL BUILDING
       ========================================================== */

    function getActiveFilterFields() {
      return Array.from(filterForm.querySelectorAll('[data-filter-param]')).filter(isFieldAvailable);
    }

    function appendCurrentGuideFilters(searchParams) {
      if (showInStockOnly) {
        searchParams.set('filter.v.availability', '1');
      }

      const activeFields = getActiveFilterFields();

      new Set(activeFields.map((field) => field.getAttribute('data-filter-param')).filter(Boolean))
        .forEach((param) => searchParams.delete(param));

      activeFields.forEach((field) => {
        const param = field.getAttribute('data-filter-param');
        if (!param) return;

        /* Checkboxes (multi-select colour) add one param per value; others are single choice. */
        if (field.type === 'checkbox') {
          searchParams.append(param, field.value);
        } else {
          searchParams.set(param, field.value);
        }
      });

      const locked = section.querySelector('[data-locked-product-type]');
      const lockedValue = locked ? (locked.dataset.productTypeValue || '').trim() : '';

      if (lockedValue) {
        searchParams.set('filter.p.product_type', lockedValue);
      }
    }

    function buildFilteredUrl(options = {}) {
      const keepPage = options.keepPage === true;
      const baseUrl = filterForm.getAttribute('data-base-url') || window.location.pathname;

      let targetUrl = new URL(baseUrl, window.location.origin);

      if (targetUrl.origin !== window.location.origin) {
        console.warn('Goalie Guide: external filter collection URLs are not supported. Using the current collection URL instead.');
        targetUrl = new URL(window.location.pathname, window.location.origin);
      }

      const currentParams = new URLSearchParams(window.location.search);
      const nextParams = new URLSearchParams();

      currentParams.forEach((value, key) => {
        if (controlledParams.has(key)) return;
        if (key === 'page' && !keepPage) return;
        if (key === 'section_id' || key === 'sections') return;
        nextParams.append(key, value);
      });

      appendCurrentGuideFilters(nextParams);
      targetUrl.search = nextParams.toString();

      return targetUrl;
    }

    /* ==========================================================
       CHIPS + RESULT BUTTON
       ========================================================== */

    function getFieldDisplayValue(field) {
      if (field.matches('select')) {
        const selected = field.options[field.selectedIndex];
        return selected ? (selected.dataset.optionLabel || selected.textContent.trim()) : field.value;
      }

      if (isToggleInput(field)) {
        return (
          field.dataset.productTypeLabel ||
          field.dataset.optionLabel ||
          field.closest('label')?.querySelector('span')?.textContent.trim() ||
          field.value
        );
      }

      return field.value;
    }

    function updateActiveFilterChips() {
      if (!activeChips || !activeChipList) return;

      activeChipList.innerHTML = '';

      getActiveFilterFields().forEach((field) => {
        const param = field.getAttribute('data-filter-param');
        const label = field.dataset.filterLabel || '';
        const value = getFieldDisplayValue(field);
        if (!param || !value) return;

        const chip = document.createElement('button');
        const chipText = document.createElement('span');
        const removeIcon = document.createElement('span');

        chip.type = 'button';
        chip.className = 'goalie-guide__chip';
        chip.dataset.removeFilterParam = param;
        chip.dataset.removeFilterValue = field.value;
        chip.setAttribute('aria-label', `Remove ${label ? `${label}: ` : ''}${value}`);

        chipText.textContent = label ? `${label}: ${value}` : value;

        removeIcon.className = 'goalie-guide__chip-remove';
        removeIcon.setAttribute('aria-hidden', 'true');
        removeIcon.textContent = '×';

        chip.append(chipText, removeIcon);
        activeChipList.appendChild(chip);
      });

      activeChips.hidden = activeChipList.children.length === 0;
    }

    function updateViewResultsCount(productCount = section.dataset.productCount) {
      if (!viewResultsButton) return;

      const count = Number(productCount);
      const hasCount = productCount !== '' && Number.isFinite(count);
      const defaultLabel = viewResultsButton.dataset.defaultLabel || viewResultsButton.textContent.trim();
      const countLabel = viewResultsButton.dataset.countLabel || 'View [count] matching goalie sticks';
      const hasSelections = getActiveFilterFields().length > 0;

      viewResultsButton.textContent =
        hasCount && hasSelections
          ? countLabel.replace('[count]', count.toLocaleString())
          : defaultLabel;

      viewResultsButton.disabled = isRefreshing || (hasCount && count === 0);
    }

    /* ==========================================================
       LOADING STATE
       ========================================================== */

    function setLoading(isLoading, message = '') {
      isRefreshing = isLoading;

      const productContainer = document.querySelector('[data-products-container]');
      if (productContainer) {
        productContainer.classList.toggle('buyer-guide-products-loading', isLoading);
        productContainer.setAttribute('aria-busy', String(isLoading));
      }

      if (successMessageTimer) {
        window.clearTimeout(successMessageTimer);
        successMessageTimer = null;
      }

      section.querySelectorAll('[data-goalie-guide-specs-box]').forEach((box) => {
        box.classList.toggle('is-loading', isLoading);
        box.setAttribute('aria-busy', String(isLoading));
        const status = box.querySelector('[data-goalie-guide-specs-status]');
        if (status) status.textContent = message;
      });

      const globalStatus = section.querySelector('[data-goalie-guide-global-status]');
      if (globalStatus) globalStatus.textContent = message;

      updateViewResultsCount();

      if (!isLoading && message === updatedFiltersText) {
        successMessageTimer = window.setTimeout(() => {
          section
            .querySelectorAll('[data-goalie-guide-specs-status], [data-goalie-guide-global-status]')
            .forEach((status) => {
              if (status.textContent === updatedFiltersText) status.textContent = '';
            });
        }, 1500);
      }
    }

    /* ==========================================================
       PRESERVE SPEC VALUES ACROSS REFRESHES
       ========================================================== */

    function getCurrentSpecSelections() {
      const selections = new Map();

      section
        .querySelectorAll('[data-goalie-guide-specs-grid] [data-filter-param]')
        .forEach((field) => {
          const param = field.getAttribute('data-filter-param');
          if (!param) return;

          if (isToggleInput(field)) {
            if (field.checked) {
              selections.set(param, [...(selections.get(param) || []), field.value]);
            }
            return;
          }

          if (field.value) selections.set(param, [field.value]);
        });

      return selections;
    }

    function restoreValidSpecSelections(selections) {
      section
        .querySelectorAll('[data-goalie-guide-specs-grid] [data-filter-param]')
        .forEach((field) => {
          const param = field.getAttribute('data-filter-param');
          if (!param) return;

          const previousValues = selections.get(param) || [];

          if (isToggleInput(field)) {
            field.checked = previousValues.includes(field.value);
            return;
          }

          const previousValue = previousValues[0];
          if (!previousValue) return;

          if (field.matches('select')) {
            const match = Array.from(field.options).find((option) => option.value === previousValue);
            field.value = match && !match.disabled ? previousValue : '';
          } else {
            field.value = previousValue;
          }
        });
    }

    function updateGuideFromFreshPage(freshDocument, previousSelections, targetUrl) {
      const sectionId = section.dataset.sectionId;
      const freshSection =
        freshDocument.getElementById(`GoalieGuide-${sectionId}`) ||
        freshDocument.querySelector(ROOT_SELECTOR);

      if (!freshSection) {
        throw new Error('Updated Goalie Guide section was not returned.');
      }

      const currentTypeRegion = section.querySelector('[data-goalie-guide-product-type-region]');
      const freshTypeRegion = freshSection.querySelector('[data-goalie-guide-product-type-region]');
      const currentMode = currentTypeRegion?.querySelector('[data-product-type-mode]')?.dataset.productTypeMode || '';
      const freshMode = freshTypeRegion?.querySelector('[data-product-type-mode]')?.dataset.productTypeMode || '';

      if (currentTypeRegion && freshTypeRegion && currentMode === freshMode) {
        currentTypeRegion.innerHTML = freshTypeRegion.innerHTML;
        restoreProductTypeFromUrl(targetUrl.search);
      }

      const freshGrids = Array.from(freshSection.querySelectorAll('[data-goalie-guide-specs-grid]'));
      const currentGrids = Array.from(section.querySelectorAll('[data-goalie-guide-specs-grid]'));

      if (freshGrids.length > 0 && freshGrids.length === currentGrids.length) {
        currentGrids.forEach((grid, index) => {
          grid.innerHTML = freshGrids[index].innerHTML;
        });
        restoreValidSpecSelections(previousSelections);
      }

      section.dataset.productCount = freshSection.dataset.productCount || '';

      updateActiveFilterChips();
      updateViewResultsCount();
    }

    /* ==========================================================
       SHARK THEME UPDATES
       ========================================================== */

    function updateSharkProducts(freshDocument) {
      const currentProducts = document.querySelector('[data-products-container]');
      const freshProducts = freshDocument.querySelector('[data-products-container]');

      if (!currentProducts || !freshProducts) {
        console.warn('Goalie Guide: Shark product container could not be found.');
        return false;
      }

      currentProducts.innerHTML = freshProducts.innerHTML;

      if (typeof window.initQuickView === 'function') {
        currentProducts.querySelectorAll('[data-quickview-action]').forEach((element) => {
          window.initQuickView(element);
        });
      }

      if (typeof window.colorSwatchesMediaChanged === 'function') {
        window.colorSwatchesMediaChanged(currentProducts);
      }

      return true;
    }

    function updateSharkSorting(freshDocument) {
      const currentSorting = document.querySelector('[data-sorting-content]');
      const freshSorting = freshDocument.querySelector('[data-sorting-content]');

      if (currentSorting && freshSorting) {
        currentSorting.innerHTML = freshSorting.innerHTML;
        if (typeof window.sortByOptions === 'function') window.sortByOptions();
      }

      const currentSortHidden = document.querySelector('.hidden_sort_by');
      const freshSortSelected = freshDocument.querySelector('.sort-by-selected');

      if (currentSortHidden && freshSortSelected) {
        currentSortHidden.value = freshSortSelected.value;
      }
    }

    function updateSharkResultCount(freshDocument) {
      const currentCount = document.querySelector('[data-search-result-count]');
      const freshCount = freshDocument.querySelector('[data-search-result-count]');
      if (currentCount && freshCount) currentCount.textContent = freshCount.textContent;
    }

    function getSharkFilterKey(filterItem) {
      const fieldNames = Array.from(
        filterItem.querySelectorAll('input[name^="filter."], select[name^="filter."]')
      )
        .map((field) => field.name)
        .filter(Boolean)
        .sort();

      if (fieldNames.length > 0) return fieldNames.join('|');

      const filterParam = filterItem.querySelector('[data-filter-param]')?.getAttribute('data-filter-param');
      if (filterParam) return filterParam;

      const heading = filterItem.querySelector('.filter-option-name, .filter-item-title, summary');
      return heading ? normalizeHandle(heading.textContent) : '';
    }

    function updateSharkNativeFilters(freshDocument) {
      const currentItems = document.querySelectorAll('.filter-item');
      const freshItems = freshDocument.querySelectorAll('.filter-item');
      if (!currentItems.length || !freshItems.length) return;

      const currentByKey = new Map(
        Array.from(currentItems)
          .map((item) => [getSharkFilterKey(item), item])
          .filter(([key]) => Boolean(key))
      );

      freshItems.forEach((freshItem) => {
        const currentItem = currentByKey.get(getSharkFilterKey(freshItem));
        if (!currentItem) return;

        if (currentItem.querySelector('.price-slider-range-min')) {
          [
            '.filter-option-range-input',
            '.filter-option-price-input',
            '.filter-option-price-slider'
          ].forEach((selector) => {
            const current = currentItem.querySelector(selector);
            const fresh = freshItem.querySelector(selector);
            if (current && fresh) current.innerHTML = fresh.innerHTML;
          });
        } else {
          const currentList = currentItem.querySelector('.filter-option-list');
          const freshList = freshItem.querySelector('.filter-option-list');
          if (currentList && freshList) currentList.innerHTML = freshList.innerHTML;
        }
      });
    }

    function reinitializeSharkCollection() {
      if (typeof window.removeFilter === 'function') window.removeFilter();
      if (typeof window.applyFilters === 'function') window.applyFilters('updated');
      if (typeof window.customDropdownElements === 'function') window.customDropdownElements();
      if (typeof window.showMoreFilters === 'function') window.showMoreFilters();
      if (typeof window.sideDrawerInt === 'function') window.sideDrawerInt();
      if (typeof window.loadMoreCollection === 'function') window.loadMoreCollection();
      if (typeof window.productCardHoverInit === 'function') window.productCardHoverInit();

      if (
        typeof window.animationStatus !== 'undefined' &&
        window.animationStatus &&
        window.AOS &&
        typeof window.AOS.refreshHard === 'function'
      ) {
        window.AOS.refreshHard();
      }
    }

    function updateBrowserUrl(targetUrl) {
      /* buyerGuideFilters flag tells the shared history patch to skip merging. */
      window.history.replaceState(
        { buyerGuideFilters: true },
        '',
        `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`
      );
    }

    /* ==========================================================
       FETCHING (Section Rendering API with full-page fallback)
       ========================================================== */

    function getShopifySectionId(element) {
      const wrapper = element?.closest('[id^="shopify-section-"]');
      return wrapper ? wrapper.id.replace('shopify-section-', '') : '';
    }

    async function fetchHtmlDocument(url, signal) {
      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal
      });

      if (!response.ok) {
        throw new Error(`Goalie Guide filter request failed with status ${response.status}`);
      }

      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    async function fetchFilteredDocument(targetUrl, signal) {
      const guideSectionId = section.dataset.sectionId || getShopifySectionId(section);
      const collectionSectionId = getShopifySectionId(document.querySelector('[data-products-container]'));
      const sidebarFilterItem = document.querySelector('.filter-item');
      const sidebarSectionId = getShopifySectionId(sidebarFilterItem);

      if (sidebarFilterItem && !sidebarSectionId) {
        return fetchHtmlDocument(targetUrl, signal);
      }

      const sectionIds = Array.from(
        new Set([guideSectionId, collectionSectionId, sidebarSectionId].filter(Boolean))
      );

      if (sectionIds.length > 0) {
        const sectionUrl = new URL(targetUrl.toString());
        sectionUrl.searchParams.set('sections', sectionIds.join(','));

        const response = await fetch(sectionUrl.toString(), {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          signal
        });

        if (response.ok) {
          const rendered = await response.json();
          const allReturned = sectionIds.every((id) => typeof rendered[id] === 'string');

          if (allReturned) {
            const renderedDocument = new DOMParser().parseFromString(
              `<html><body>${sectionIds.map((id) => rendered[id]).join('')}</body></html>`,
              'text/html'
            );

            if (
              (renderedDocument.getElementById(`GoalieGuide-${guideSectionId}`) ||
                renderedDocument.querySelector(ROOT_SELECTOR)) &&
              renderedDocument.querySelector('[data-products-container]')
            ) {
              return renderedDocument;
            }
          }
        }
      }

      return fetchHtmlDocument(targetUrl, signal);
    }

    /* ==========================================================
       LIVE REFRESH
       ========================================================== */

    async function refreshGuideAndProducts(options = {}) {
      if (refreshController) refreshController.abort();
      refreshController = new AbortController();

      const previousSelections = getCurrentSpecSelections();
      const targetUrl = buildFilteredUrl(options);

      setLoading(true, updatingFiltersText);

      try {
        const freshDocument = await fetchFilteredDocument(targetUrl, refreshController.signal);

        updateGuideFromFreshPage(freshDocument, previousSelections, targetUrl);
        const productsUpdated = updateSharkProducts(freshDocument);
        updateSharkNativeFilters(freshDocument);
        updateSharkSorting(freshDocument);
        updateSharkResultCount(freshDocument);
        reinitializeSharkCollection();
        updateBrowserUrl(targetUrl);

        document.dispatchEvent(
          new CustomEvent('buyer-guide:products-updated', {
            detail: {
              guide: 'goalie',
              url: targetUrl.toString(),
              productCount: section.dataset.productCount,
              productsUpdated
            }
          })
        );

        setLoading(false, updatedFiltersText);
      } catch (error) {
        if (error.name === 'AbortError') return;

        console.error('Goalie Guide AJAX refresh error:', error);

        restoreFieldsFromUrl();
        updateActiveFilterChips();
        updateViewResultsCount();
        setLoading(false, filterUpdateErrorText);
      }
    }

    function scheduleRefresh(delay = refreshDelay, options = {}) {
      if (refreshTimer) window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(
        () => refreshGuideAndProducts(options),
        Math.max(0, Number(delay) || 0)
      );
    }

    function scrollToProductGrid() {
      const grid = document.querySelector('[data-products-container]');
      if (!grid) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      grid.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    /* ==========================================================
       INITIAL STATE
       ========================================================== */

    restoreProductTypeFromUrl();
    updateActiveFilterChips();
    updateViewResultsCount();

    /* ==========================================================
       EVENTS
       ========================================================== */

    filterForm.addEventListener('change', (event) => {
      const field = event.target.closest('[data-filter-param]');
      if (!field || !filterForm.contains(field)) return;

      if (field.matches('[data-product-type-option]')) {
        if (!field.checked) return;

        /* Different goalie stick types can have different spec ranges. */
        clearSpecSelections();
        openSpecsCard();
        updateActiveFilterChips();
        scheduleRefresh(0);
        return;
      }

      updateActiveFilterChips();
      scheduleRefresh();
    });

    filterForm.addEventListener('input', (event) => {
      const field = event.target.closest('input[type="number"][data-filter-param]');
      if (!field) return;

      updateActiveFilterChips();
      scheduleRefresh(Math.max(500, Number(refreshDelay) || 0));
    });

    filterForm.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!isRefreshing) scrollToProductGrid();
    });

    if (viewResultsButton) {
      viewResultsButton.addEventListener('click', () => {
        if (!isRefreshing) scrollToProductGrid();
      });
    }

    if (clearAllButton) {
      clearAllButton.addEventListener('click', () => {
        filterForm.querySelectorAll('[data-filter-param]').forEach(clearInput);

        const anyTypeOption = getProductTypeOptions().find((option) => option.value === '');
        if (anyTypeOption) anyTypeOption.checked = true;

        updateActiveFilterChips();
        scheduleRefresh(0);
      });
    }

    if (activeChipList) {
      activeChipList.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-remove-filter-param]');
        if (!chip) return;

        const param = chip.dataset.removeFilterParam;
        const matchingFields = Array.from(filterForm.querySelectorAll('[data-filter-param]')).filter(
          (field) => field.getAttribute('data-filter-param') === param
        );

        if (param === 'filter.p.product_type') {
          matchingFields.forEach((field) => { field.checked = field.value === ''; });
          clearSpecSelections();
        } else {
          const valueToRemove = chip.dataset.removeFilterValue;

          matchingFields.forEach((field) => {
            if (field.type === 'checkbox' && valueToRemove && field.value !== valueToRemove) return;
            clearInput(field);
          });
        }

        updateActiveFilterChips();
        scheduleRefresh(0);
      });
    }

    /* ==========================================================
       URL NORMALIZATION (applies in-stock + locked type on load)
       ========================================================== */

    function urlNeedsNormalization() {
      const normalizedUrl = buildFilteredUrl({ keepPage: true });
      const normalizedParams = new URLSearchParams(normalizedUrl.search);
      const currentParams = new URLSearchParams(window.location.search);

      normalizedParams.delete('page');
      currentParams.delete('page');
      normalizedParams.sort();
      currentParams.sort();

      return (
        normalizedUrl.pathname !== window.location.pathname ||
        normalizedParams.toString() !== currentParams.toString()
      );
    }

    let lastNormalizedFrom = '';
    let normalizeCheckTimer = null;

    function checkNormalization() {
      if (isRefreshing || !urlNeedsNormalization()) return;

      const currentUrl = `${window.location.pathname}${window.location.search}`;
      if (currentUrl === lastNormalizedFrom) return;

      lastNormalizedFrom = currentUrl;
      scheduleRefresh(0, { keepPage: true });
    }

    function queueNormalizationCheck() {
      if (normalizeCheckTimer) window.clearTimeout(normalizeCheckTimer);
      normalizeCheckTimer = window.setTimeout(checkNormalization, 300);
    }

    /* ==========================================================
       MERGE GUIDE FILTERS INTO SHARK REQUESTS

       Shares the same global patch as the main Buyer Guide, so if
       both section scripts load, fetch/XHR/history are patched once.
       ========================================================== */

    function mergeGuideFiltersIntoUrl(rawUrl) {
      let url;

      try {
        url = new URL(rawUrl, window.location.href);
      } catch (error) {
        return rawUrl;
      }

      if (url.origin !== window.location.origin || url.pathname !== buildFilteredUrl().pathname) {
        return rawUrl;
      }

      const guideParams = new URLSearchParams();
      appendCurrentGuideFilters(guideParams);
      new Set(guideParams.keys()).forEach((key) => {
        url.searchParams.delete(key);
        guideParams.getAll(key).forEach((value) => url.searchParams.append(key, value));
      });

      return `${url.pathname}${url.search}${url.hash}`;
    }

    window.__buyerGuideUrlMergers = window.__buyerGuideUrlMergers || [];
    window.__buyerGuideUrlMergers.push({ section, merge: mergeGuideFiltersIntoUrl });

    if (!window.__buyerGuideRequestsPatched) {
      window.__buyerGuideRequestsPatched = true;

      const applyMergers = (rawUrl) =>
        (window.__buyerGuideUrlMergers || [])
          .filter((entry) => entry.section.isConnected)
          .reduce((currentUrl, entry) => entry.merge(currentUrl), rawUrl);

      const originalFetch = window.fetch;

      window.fetch = function (input, init) {
        try {
          const method = (init && init.method) || (input instanceof Request ? input.method : 'GET');

          if (String(method).toUpperCase() === 'GET') {
            if (typeof input === 'string' || input instanceof URL) {
              input = applyMergers(String(input));
            } else if (input instanceof Request) {
              const mergedUrl = applyMergers(input.url);
              if (mergedUrl !== input.url) input = new Request(mergedUrl, input);
            }
          }
        } catch (error) {}

        return originalFetch.call(this, input, init);
      };

      const originalOpen = XMLHttpRequest.prototype.open;

      XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        try {
          if (url && String(method).toUpperCase() === 'GET') {
            url = applyMergers(String(url));
          }
        } catch (error) {}

        return originalOpen.call(this, method, url, ...rest);
      };

      ['pushState', 'replaceState'].forEach((method) => {
        const original = window.history[method];

        window.history[method] = function (state, title, url) {
          const isGuideUpdate = state && state.buyerGuideFilters;

          if (url && !isGuideUpdate) {
            try {
              url = applyMergers(String(url));
            } catch (error) {}
          }

          const result = original.call(this, state, title, url);

          document.dispatchEvent(
            new CustomEvent('buyer-guide:history-change', { detail: { state } })
          );

          return result;
        };
      });

      document.addEventListener(
        'click',
        (event) => {
          const link = event.target.closest && event.target.closest('a[href]');
          if (!link) return;

          const href = link.getAttribute('href');
          if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

          try {
            const mergedHref = applyMergers(href);
            if (mergedHref !== href) link.setAttribute('href', mergedHref);
          } catch (error) {}
        },
        true
      );
    }

    document.addEventListener('buyer-guide:history-change', (event) => {
      if (event.detail?.state?.buyerGuideFilters) return;
      queueNormalizationCheck();
    });

    window.addEventListener('popstate', queueNormalizationCheck);

    const productsContainerToWatch = document.querySelector('[data-products-container]');
    if (productsContainerToWatch) {
      new MutationObserver(queueNormalizationCheck).observe(productsContainerToWatch, { childList: true });
    }

    if (urlNeedsNormalization()) {
      lastNormalizedFrom = `${window.location.pathname}${window.location.search}`;
      scheduleRefresh(0, { keepPage: true });
    }
  }

  function initializeGoalieGuides(root = document) {
    const guides = [];

    if (root.matches && root.matches(ROOT_SELECTOR)) guides.push(root);

    if (root.querySelectorAll) {
      root.querySelectorAll(ROOT_SELECTOR).forEach((guide) => {
        if (!guides.includes(guide)) guides.push(guide);
      });
    }

    guides.forEach(initGoalieGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeGoalieGuides(document), { once: true });
  } else {
    initializeGoalieGuides(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeGoalieGuides(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buyer-guide-search-alert"] && !Shopify.designMode) return;
  try {
    
(() => {

  const KLAVIYO_REVISION = '2024-10-15';
  const STORAGE_KEY = 'hsm_search_alerts_v1';
  const TYPE_PARAM = 'filter.p.product_type';

  // [URL param, chip label, event property name]
  const SPEC_PARAMS = [
    ['filter.v.m.custom.hand', 'Hand', 'hand'],
    ['filter.v.m.custom.curve', 'Curve', 'curve'],
    ['filter.v.m.custom.flex_range', 'Flex', 'flex_range'],
    ['filter.v.m.custom.height_range', 'Height', 'height_range'],
    ['filter.v.m.custom.kick_point', 'Kick point', 'kick_point'],
    ['filter.v.m.custom.grip', 'Grip', 'grip'],
    ['filter.p.vendor', 'Brand', 'brand']
  ];

  const PRICE_PARAMS = [
    ['filter.v.price.gte', 'Min $', 'price_min'],
    ['filter.v.price.lte', 'Max $', 'price_max']
  ];

  const handle = (value = '') =>
    value.toString().trim().toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  // Small stable hash so the same criteria always get the same search_id.
  function hashString(input) {
    let hash = 5381;
    for (let i = 0; i < input.length; i += 1) {
      hash = ((hash << 5) + hash + input.charCodeAt(i)) >>> 0;
    }
    return hash.toString(36);
  }

  function readWatched() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function addWatched(searchId) {
    try {
      const watched = readWatched().filter((id) => id !== searchId);
      watched.push(searchId);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(watched.slice(-50)));
    } catch (error) {}
  }

  // Use the Buyer Guide's own option label when it exists (e.g. nicer curve names).
  function labelFor(param, value) {
    const selects = document.querySelectorAll('select[data-filter-param]');
    for (const select of selects) {
      if (select.getAttribute('data-filter-param') !== param) continue;
      const option = Array.from(select.options).find((opt) => opt.value === value);
      if (option) return option.dataset.optionLabel || option.textContent.trim();
    }
    return value;
  }

  function initSearchAlert(section) {

    if (!section || section.dataset.searchAlertInitialized === 'true') return;
    section.dataset.searchAlertInitialized = 'true';

    const form = section.querySelector('[data-sa-form]');
    const emailInput = section.querySelector('[data-sa-email]');
    const submitButton = section.querySelector('[data-sa-submit]');
    const statusEl = section.querySelector('[data-sa-status]');
    const chipList = section.querySelector('[data-sa-chips]');
    const headingEl = section.querySelector('[data-sa-heading]');
    const textEl = section.querySelector('[data-sa-text]');
    const doneEl = section.querySelector('[data-sa-done]');
    const doneTextEl = section.querySelector('[data-sa-done-text]');

    const settings = section.dataset;
    const minSpecs = Math.max(1, Number(settings.minSpecs) || 2);
    const requireHand = settings.requireHand === 'true';
    const blackoutHandle = handle(settings.blackoutValue);

    let current = null;
    let lastProductCount = null;
    let isSubmitting = false;

    function readCriteria() {

      const params = new URLSearchParams(window.location.search);
      const criteria = {};
      const chips = [];
      let specCount = 0;

      const productType =
        params.get(TYPE_PARAM) ||
        settings.defaultProductType ||
        '';

      if (productType) criteria.product_type = productType;

      SPEC_PARAMS.forEach(([param, label, key]) => {
        const value = params.get(param);
        if (!value) return;
        criteria[key] = value;
        chips.push([label, labelFor(param, value)]);
        specCount += 1;
      });

      PRICE_PARAMS.forEach(([param, label, key]) => {
        const value = params.get(param);
        if (!value) return;
        criteria[key] = value;
        chips.push([label, value]);
      });

      const typeHandles = productType.split(',').map(handle).filter(Boolean);
      const isBlackout =
        (blackoutHandle && typeHandles.includes(blackoutHandle)) ||
        typeHandles.some((value) => value.includes('blackout'));

      const eligible =
        !isBlackout &&
        specCount >= minSpecs &&
        (!requireHand || Boolean(criteria.hand));

      // Link back to exactly this filtered view, in-stock only.
      const searchUrl = new URL(window.location.pathname, window.location.origin);
      [TYPE_PARAM, ...SPEC_PARAMS.map(([p]) => p), ...PRICE_PARAMS.map(([p]) => p)]
        .forEach((param) => {
          const value = params.get(param);
          if (value) searchUrl.searchParams.set(param, value);
        });
      searchUrl.searchParams.set('filter.v.availability', '1');

      const stableKey = JSON.stringify(
        Object.keys(criteria).sort().map((key) => [key, handle(criteria[key])])
      );

      return {
        criteria,
        chips,
        eligible,
        searchId: `ss_${hashString(stableKey)}`,
        searchUrl: searchUrl.toString(),
        summary: chips.map(([label, value]) => `${label} ${value}`).join(', ')
      };
    }

    function getProductCount() {
      if (lastProductCount !== null) return lastProductCount;
      const guide = document.querySelector('[data-buyer-guide-root]');
      const count = guide ? Number(guide.dataset.productCount) : NaN;
      return Number.isFinite(count) ? count : null;
    }

    function setStatus(message) {
      statusEl.textContent = message || '';
    }

    function showDone(message) {
      form.hidden = true;
      doneEl.hidden = false;
      doneTextEl.textContent = message;
    }

    function showForm() {
      form.hidden = false;
      doneEl.hidden = true;
    }

    function render() {

      if (settings.configured !== 'true' && !window.Shopify?.designMode) {
        section.hidden = true;
        return;
      }

      const next = readCriteria();
      const changed = !current || current.searchId !== next.searchId;
      current = next;

      if (!next.eligible) {
        section.hidden = true;
        return;
      }

      section.hidden = false;

      const count = getProductCount();
      const noResults = count === 0;
      headingEl.textContent = noResults ? settings.emptyHeading : settings.heading;
      textEl.textContent = noResults ? settings.emptyText : settings.text;

      chipList.innerHTML = '';
      next.chips.forEach(([label, value]) => {
        const chip = document.createElement('li');
        const labelEl = document.createElement('b');
        chip.className = 'search-alert__chip';
        labelEl.textContent = label;
        chip.append(labelEl, document.createTextNode(value));
        chipList.appendChild(chip);
      });

      if (changed) {
        setStatus('');
        emailInput.removeAttribute('aria-invalid');
        if (readWatched().includes(next.searchId)) {
          showDone(settings.watchingText);
        } else {
          showForm();
        }
      }
    }

    async function klaviyoPost(path, body) {
      const url =
        `https://a.klaviyo.com/client/${path}/?company_id=${encodeURIComponent(settings.publicKey)}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(body)
      });
      if (!response.ok) {
        throw new Error(`Klaviyo ${path} failed with status ${response.status}`);
      }
    }

    form.addEventListener('submit', async (event) => {

      event.preventDefault();
      if (isSubmitting || !current || !current.eligible) return;

      const email = emailInput.value.trim();
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!emailValid) {
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
        setStatus(settings.emailErrorText);
        return;
      }

      emailInput.removeAttribute('aria-invalid');

      if (settings.configured !== 'true') {
        setStatus('Klaviyo is not configured for this section yet.');
        return;
      }

      const snapshot = current;
      isSubmitting = true;
      submitButton.disabled = true;
      setStatus('');

      try {

        await klaviyoPost('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Collection search alert',
              profile: {
                data: { type: 'profile', attributes: { email } }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: settings.listId } }
            }
          }
        });

        await klaviyoPost('events', {
          data: {
            type: 'event',
            attributes: {
              properties: {
                ...snapshot.criteria,
                search_id: snapshot.searchId,
                search_url: snapshot.searchUrl,
                search_summary: snapshot.summary,
                collection_handle: settings.collectionHandle,
                collection_title: settings.collectionTitle,
                results_at_signup: getProductCount(),
                source: 'collection_search_alert'
              },
              metric: {
                data: { type: 'metric', attributes: { name: settings.metricName } }
              },
              profile: {
                data: { type: 'profile', attributes: { email } }
              }
            }
          }
        });

        addWatched(snapshot.searchId);
        showDone(settings.successText);

        document.dispatchEvent(new CustomEvent('search-alert:created', {
          detail: { searchId: snapshot.searchId, criteria: snapshot.criteria }
        }));

      } catch (error) {
        console.error('Search alert error:', error);
        setStatus(settings.errorText);
      } finally {
        isSubmitting = false;
        submitButton.disabled = false;
      }
    });

    // Re-read the URL whenever the Buyer Guide or Shark changes the filters.
    document.addEventListener('buyer-guide:products-updated', (event) => {
      const count = Number(event.detail?.productCount);
      lastProductCount = Number.isFinite(count) ? count : null;
      render();
    });

    document.addEventListener('buyer-guide:history-change', () => {
      lastProductCount = null;
      window.setTimeout(render, 0);
    });

    window.addEventListener('popstate', () => {
      lastProductCount = null;
      render();
    });

    render();
  }

  function initAll(root = document) {
    if (root.matches && root.matches('[data-search-alert]')) initSearchAlert(root);
    root.querySelectorAll?.('[data-search-alert]').forEach(initSearchAlert);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buyer-guide-v6"] && !Shopify.designMode) return;
  try {
    

(() => {

  function initBuyerGuide(
    section
  ) {

  if (!section) return;


  if (
    section.dataset.buyerGuideInitialized ===
    'true'
  ) {
    return;
  }


  section.dataset.buyerGuideInitialized =
    'true';


  /*
  ============================================================
  MAIN BUYER GUIDE ACCORDION
  ============================================================
  */

  const mainToggle =
    section.querySelector(
      '.buyer-guide-section__main-toggle'
    );


  const mainContent =
    section.querySelector(
      '.buyer-guide-section__content'
    );


  if (
    mainToggle &&
    mainContent
  ) {

    const startsOpen =
      section.dataset.openByDefault ===
      'true';


    section.classList.toggle(
      'is-collapsed',
      !startsOpen
    );


    mainToggle.setAttribute(
      'aria-expanded',
      String(startsOpen)
    );


    mainContent.hidden =
      !startsOpen;


    mainToggle.addEventListener(
      'click',
      () => {

        const isOpen =
          mainToggle.getAttribute(
            'aria-expanded'
          ) === 'true';


        const nextOpen =
          !isOpen;


        mainToggle.setAttribute(
          'aria-expanded',
          String(nextOpen)
        );


        mainContent.hidden =
          !nextOpen;


        section.classList.toggle(
          'is-collapsed',
          !nextOpen
        );

      }
    );

  }



    /*
  ============================================================
  MODULE ACCORDIONS
  ============================================================
  */

  const closeOtherCards =
    section.dataset.closeOtherCards === 'true';


  const cards =
    Array.from(
      section.querySelectorAll(
        '.buyer-guide-card'
      )
    );


  /*
    Matches the theme's mobile breakpoint (max-width: 749px).
    Desktop/tablet = 750px and up.
  */

  const desktopQuery =
    window.matchMedia(
      '(min-width: 750px)'
    );


  /*
    Returns true if the card contains an active shopper
    selection (a chosen dropdown, checked radio, or typed price).
  */

  function cardHasSelections(
    card
  ) {

    return Array.from(
      card.querySelectorAll(
        '[data-filter-param]'
      )
    ).some(
      (field) => {

        if (
          field.disabled
        ) {
          return false;
        }


        if (
          field.closest(
            '[data-spec-field][hidden]'
          )
        ) {
          return false;
        }


        if (
          (
            field.type === 'checkbox' ||
            field.type === 'radio'
          ) &&
          !field.checked
        ) {
          return false;
        }


        return Boolean(
          field.value
        );

      }
    );

  }


  function setCardOpen(
    card,
    open
  ) {

    const button =
      card.querySelector(
        '.buyer-guide-card__toggle'
      );


    const panel =
      card.querySelector(
        '.buyer-guide-card__panel'
      );


    card.classList.toggle(
      'is-open',
      open
    );


    if (
      button
    ) {

      button.setAttribute(
        'aria-expanded',
        String(open)
      );

    }


    if (
      panel
    ) {

      panel.hidden =
        !open;

    }

  }


  /*
    Closes every other card, except on desktop where cards
    with active selections stay open.
  */

  function closeCardsExcept(
    activeCard
  ) {

    if (
      !closeOtherCards
    ) {
      return;
    }


    cards.forEach(
      (otherCard) => {

        if (
          otherCard === activeCard
        ) {
          return;
        }


        if (
          desktopQuery.matches &&
          cardHasSelections(
            otherCard
          )
        ) {
          return;
        }


        setCardOpen(
          otherCard,
          false
        );

      }
    );

  }


  cards.forEach(
    (card) => {

      const button =
        card.querySelector(
          '.buyer-guide-card__toggle'
        );


      const panel =
        card.querySelector(
          '.buyer-guide-card__panel'
        );


      if (
        !button ||
        !panel
      ) {
        return;
      }


      button.addEventListener(
        'click',
        () => {

          const isOpen =
            card.classList.contains(
              'is-open'
            );


          if (
            !isOpen
          ) {

            closeCardsExcept(
              card
            );

          }


          setCardOpen(
            card,
            !isOpen
          );

        }
      );

    }
  );



  /*
  ============================================================
  FILTER ELEMENTS
  ============================================================
  */

  const filterForm =
    section.querySelector(
      '[data-buyer-guide-filter-form]'
    );


  if (
    !filterForm
  ) {
    return;
  }


  const clearAllButton =
    section.querySelector(
      '[data-buyer-guide-clear-all]'
    );


  const viewResultsButton =
    section.querySelector(
      '[data-buyer-guide-view-results]'
    );


  const activeChips =
    section.querySelector(
      '[data-active-filter-chips]'
    );


  const activeChipList =
    section.querySelector(
      '[data-active-filter-chip-list]'
    );


  function normalizeHandle(
    value = ''
  ) {

    return value
      .toString()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  }


  function getProductTypeOptions() {

    return Array.from(
      section.querySelectorAll(
        '[data-product-type-option]'
      )
    );

  }


  const blackoutTypeHandle =
    normalizeHandle(
      section.dataset.blackoutProductTypeValue
    );


  const retailTypeHandle =
    normalizeHandle(
      section.dataset.retailProductTypeValue
    );


  const updatingFiltersText =
    section.dataset.updatingFiltersText ||
    'Updating matching sticks…';


  const updatedFiltersText =
    section.dataset.updatedFiltersText ||
    'Matching sticks updated.';


  const filterUpdateErrorText =
    section.dataset.filterUpdateErrorText ||
    'Matching sticks could not be refreshed. Please try again.';


  const refreshDelay =
    Number(
      section.dataset.filterRefreshDelay
    ) || 0;


  const showInStockOnly =
    section.dataset.showInStockOnly ===
    'true';


  let refreshController =
    null;


  let refreshTimer =
    null;


  let successMessageTimer =
    null;


  let isRefreshing =
    false;



  /*
  ============================================================
  PRODUCT TYPE
  ============================================================
  */

  function getSelectedProductType() {

    const productTypeOptions =
      getProductTypeOptions();


    return (
      productTypeOptions.find(
        (option) =>
          option.checked
      ) ||
      section.querySelector(
        '[data-locked-product-type]'
      ) ||
      null
    );

  }



  function restoreProductTypeFromUrl(
    search = window.location.search
  ) {

    const productTypeOptions =
      getProductTypeOptions();

    if (
      productTypeOptions.length ===
      0
    ) {
      return;
    }


    const currentParams =
      new URLSearchParams(
        search
      );


    const activeValues =
      currentParams.getAll(
        'filter.p.product_type'
      );


    const activeHandles =
      activeValues
        .flatMap(
          (value) =>
            value.split(',')
        )
        .map(normalizeHandle)
        .filter(Boolean);


    const matchingOption =
      productTypeOptions.find(
        (option) => {

          const optionHandles =
            [
              ...option.value.split(','),
              ...(
                option.dataset.nativeFilterValues ||
                ''
              ).split('|||')
            ]
              .map(normalizeHandle)
              .filter(Boolean);


          return (
            activeHandles.length > 0 &&
            activeHandles.every(
              (handle) =>
                optionHandles.includes(
                  handle
                )
            )
          );

        }
      );


    const fallbackOption =
      productTypeOptions.find(
        (option) =>
          option.value === ''
      );


    productTypeOptions.forEach(
      (option) => {

        option.checked =
          false;

      }
    );


    if (
      matchingOption
    ) {

      matchingOption.checked =
        true;

    } else if (
      fallbackOption
    ) {

      fallbackOption.checked =
        true;

    }

  }



  function restoreBuyerGuideFieldsFromUrl(
    search = window.location.search
  ) {

    const params =
      new URLSearchParams(
        search
      );


    restoreProductTypeFromUrl(
      search
    );


    filterForm
      .querySelectorAll(
        '[data-filter-param]:not([data-product-type-option])'
      )
      .forEach(
        (field) => {

          const param =
            field.getAttribute(
              'data-filter-param'
            );


          if (
            !param
          ) {
            return;
          }


          const value =
            params.get(param) ||
            '';


          if (
            field.matches('select')
          ) {

            const valueExists =
              Array.from(
                field.options
              ).some(
                (option) =>
                  option.value === value
              );


            field.value =
              valueExists
                ? value
                : '';

          } else if (
            field.type === 'checkbox' ||
            field.type === 'radio'
          ) {

            field.checked =
              params
                .getAll(param)
                .includes(
                  field.value
                );

          } else {

            field.value =
              value;

          }

        }
      );

  }



  /*
  ============================================================
  OPEN SPECS CARD
  ============================================================
  */

    function openSpecsCard() {

    const specsCard =
      section.querySelector(
        '.buyer-guide-card--specs-filter-module'
      );


    if (
      !specsCard
    ) {
      return;
    }


    closeCardsExcept(
      specsCard
    );


    setCardOpen(
      specsCard,
      true
    );

  }



  /*
  ============================================================
  PRODUCT TYPE CONTINGENCIES
  ============================================================
  */

  function clearFieldValue(
    field
  ) {

    field
      .querySelectorAll(
        '[data-filter-param]'
      )
      .forEach(
        (input) => {

          if (
            input.type === 'checkbox' ||
            input.type === 'radio'
          ) {

            input.checked =
              false;

          } else {

            input.value =
              '';

          }

        }
      );

  }



  function setSpecFieldVisibility(
    fieldName,
    visible
  ) {

    section
      .querySelectorAll(
        `[data-spec-field="${fieldName}"]`
      )
      .forEach(
        (field) => {

          field.hidden =
            !visible;


          if (
            !visible
          ) {

            clearFieldValue(
              field
            );

          }

        }
      );

  }



  function applyProductTypeContingencies() {

    const selectedType =
      getSelectedProductType();


    const selectedValue =
      selectedType
        ? (
            selectedType.value ||
            selectedType.dataset.productTypeValue ||
            ''
          )
        : '';


    const selectedHandles =
      selectedValue
        .split(',')
        .map(normalizeHandle)
        .filter(Boolean);


    const selectedTypeKey =
      normalizeHandle(
        selectedType
          ? (
              selectedType.dataset.productTypeKey ||
              selectedType.dataset.productTypeLabel ||
              ''
            )
          : ''
      );


    const isBlackout =
      selectedHandles.includes(
        blackoutTypeHandle
      ) ||
      selectedTypeKey.includes(
        'blackout'
      );


    const isRetail =
      selectedHandles.includes(
        retailTypeHandle
      ) ||
      selectedTypeKey.includes(
        'retail'
      );


    /*
      Blackout:
      - hide Brand
      - hide Grip

      Retail:
      - show Brand
      - hide Grip
    */

    setSpecFieldVisibility(
      'brand',
      !isBlackout
    );


    setSpecFieldVisibility(
      'grip',
      !isBlackout &&
      !isRetail
    );

  }



  function clearSpecSelections() {

    section
      .querySelectorAll(
        '[data-buyer-guide-specs-grid] [data-filter-param]'
      )
      .forEach(
        (field) => {

          if (
            field.type === 'checkbox' ||
            field.type === 'radio'
          ) {

            field.checked =
              false;

          } else {

            field.value =
              '';

          }

        }
      );

  }



  /*
  ============================================================
  ACTIVE BUYER GUIDE FIELDS
  ============================================================
  */

  function isFieldAvailable(
    field
  ) {

    if (
      field.disabled
    ) {
      return false;
    }


    const hiddenSpecField =
      field.closest(
        '[data-spec-field][hidden]'
      );


    if (
      hiddenSpecField
    ) {
      return false;
    }


    if (
      (
        field.type === 'checkbox' ||
        field.type === 'radio'
      ) &&
      !field.checked
    ) {
      return false;
    }


    return Boolean(
      field.value
    );

  }



  function getActiveFilterFields() {

    return Array.from(
      filterForm.querySelectorAll(
        '[data-filter-param]'
      )
    ).filter(
      isFieldAvailable
    );

  }



  /*
  ============================================================
  FILTER PARAMETERS
  ============================================================
  */

  function appendPersistentFilters(
    searchParams
  ) {

    if (
      showInStockOnly
    ) {

      searchParams.set(
        'filter.v.availability',
        '1'
      );

    }

  }



  function appendCurrentBuyerGuideFilters(
    searchParams
  ) {

    appendPersistentFilters(
      searchParams
    );


    getActiveFilterFields()
      .forEach(
        (field) => {

          const filterParam =
            field.getAttribute(
              'data-filter-param'
            );


          if (
            !filterParam
          ) {
            return;
          }


          /*
            Use SET for Buyer Guide fields because
            each guide parameter is single choice.
          */

          searchParams.set(
            filterParam,
            field.value
          );

        }
      );


    const lockedProductType =
      section.querySelector(
        '[data-locked-product-type]'
      );


    if (
      lockedProductType
    ) {

      const lockedValue =
        (
          lockedProductType.dataset.productTypeValue ||
          ''
        ).trim();


      if (
        lockedValue
      ) {

        searchParams.set(
          'filter.p.product_type',
          lockedValue
        );

      }

    }

  }



  /*
  ============================================================
  PRESERVE UNRELATED SHARK / NATIVE FILTERS

  If the shopper has used another native filter that the
  Buyer Guide does not control, keep that filter active.

  Buyer Guide-controlled values are replaced by the guide.
  ============================================================
  */

  const buyerGuideControlledParams =
    new Set([
      'filter.v.availability',
      'filter.p.product_type',
      'filter.v.m.custom.hand',
      'filter.v.m.custom.curve',
      'filter.v.m.custom.flex_range',
      'filter.v.m.custom.height_range',
      'filter.v.m.custom.kick_point',
      'filter.v.m.custom.grip',
      'filter.p.vendor',
      'filter.v.price.gte',
      'filter.v.price.lte'
    ]);


  function buildFilteredUrl(
    options = {}
  ) {

    const keepPage =
      options.keepPage === true;

    const baseUrl =
      filterForm.getAttribute(
        'data-base-url'
      ) ||
      window.location.pathname;


    let targetUrl =
      new URL(
        baseUrl,
        window.location.origin
      );


    if (
      targetUrl.origin !==
      window.location.origin
    ) {

      console.warn(
        'Buyer Guide: external filter collection URLs are not supported. Using the current collection URL instead.'
      );


      targetUrl =
        new URL(
          window.location.pathname,
          window.location.origin
        );

    }


    const currentParams =
      new URLSearchParams(
        window.location.search
      );


    const nextParams =
      new URLSearchParams();


    /*
      Keep unrelated URL state / native filters.

      Do NOT preserve:
      - Buyer Guide-controlled params
      - Shopify pagination page
      - section_id
    */

    currentParams.forEach(
      (value, key) => {

        if (
          buyerGuideControlledParams.has(
            key
          )
        ) {
          return;
        }


        if (
          key === 'page' &&
          !keepPage
        ) {
          return;
        }


        if (
          key === 'section_id' ||
          key === 'sections'
        ) {
          return;
        }


        nextParams.append(
          key,
          value
        );

      }
    );


    appendCurrentBuyerGuideFilters(
      nextParams
    );


    targetUrl.search =
      nextParams.toString();


    return targetUrl;

  }



  /*
  ============================================================
  ACTIVE FILTER DISPLAY VALUE
  ============================================================
  */

  function getFieldDisplayValue(
    field
  ) {

    if (
      field.matches(
        'select'
      )
    ) {

      const selectedOption =
        field.options[
          field.selectedIndex
        ];


      return (
        selectedOption
          ? (
              selectedOption.dataset.optionLabel ||
              selectedOption.textContent.trim()
            )
          : field.value
      );

    }


    if (
      field.type === 'radio' ||
      field.type === 'checkbox'
    ) {

      return (
        field.dataset.productTypeLabel ||
        field
          .closest('label')
          ?.querySelector('span')
          ?.textContent.trim() ||
        field.value
      );

    }


    return field.value;

  }



  /*
  ============================================================
  BUYER GUIDE ACTIVE CHIPS
  ============================================================
  */

  function updateActiveFilterChips() {

    if (
      !activeChips ||
      !activeChipList
    ) {
      return;
    }


    const activeFields =
      getActiveFilterFields();


    activeChipList.innerHTML =
      '';


    activeFields.forEach(
      (field) => {

        const filterParam =
          field.getAttribute(
            'data-filter-param'
          );


        const filterLabel =
          field.dataset.filterLabel ||
          '';


        const filterValue =
          getFieldDisplayValue(
            field
          );


        if (
          !filterParam ||
          !filterValue
        ) {
          return;
        }


        const chip =
          document.createElement(
            'button'
          );


        const chipText =
          document.createElement(
            'span'
          );


        const removeIcon =
          document.createElement(
            'span'
          );


        chip.type =
          'button';


        chip.className =
          'buyer-guide-section__chip';


        chip.dataset.removeFilterParam =
          filterParam;


        chip.setAttribute(
          'aria-label',
          `Remove ${
            filterLabel
              ? `${filterLabel}: `
              : ''
          }${filterValue}`
        );


        chipText.textContent =
          filterLabel
            ? `${filterLabel}: ${filterValue}`
            : filterValue;


        removeIcon.className =
          'buyer-guide-section__chip-remove';


        removeIcon.setAttribute(
          'aria-hidden',
          'true'
        );


        removeIcon.textContent =
          '×';


        chip.append(
          chipText,
          removeIcon
        );


        activeChipList.appendChild(
          chip
        );

      }
    );


    activeChips.hidden =
      activeChipList.children.length ===
      0;

  }



  /*
  ============================================================
  MATCHING PRODUCT COUNT
  ============================================================
  */

  function updateViewResultsCount(
    productCount =
      section.dataset.productCount
  ) {

    if (
      !viewResultsButton
    ) {
      return;
    }


    const count =
      Number(
        productCount
      );


    const hasCount =
      productCount !== '' &&
      Number.isFinite(
        count
      );


    const defaultLabel =
      viewResultsButton.dataset.defaultLabel ||
      viewResultsButton.textContent.trim();


    const countLabel =
      viewResultsButton.dataset.countLabel ||
      'View [count] matching sticks';


    const hasShopperSelections =
      getActiveFilterFields().length > 0;


    viewResultsButton.textContent =
      hasCount &&
      hasShopperSelections
        ? countLabel.replace(
            '[count]',
            count.toLocaleString()
          )
        : defaultLabel;


    viewResultsButton.disabled =
      isRefreshing ||
      (
        hasCount &&
        count === 0
      );

  }



  /*
  ============================================================
  LOADING STATE
  ============================================================
  */

  function setLoading(
    isLoading,
    message = ''
  ) {

    const specsBoxes =
      Array.from(
        section.querySelectorAll(
          '[data-buyer-guide-specs-box]'
        )
      );


    isRefreshing =
      isLoading;


    const productContainer =
      document.querySelector(
        '[data-products-container]'
      );


    if (
      productContainer
    ) {

      productContainer.classList.toggle(
        'buyer-guide-products-loading',
        isLoading
      );


      productContainer.setAttribute(
        'aria-busy',
        String(isLoading)
      );

    }


    if (
      successMessageTimer
    ) {

      window.clearTimeout(
        successMessageTimer
      );


      successMessageTimer =
        null;

    }


    specsBoxes.forEach(
      (box) => {

        box.classList.toggle(
          'is-loading',
          isLoading
        );


        box.setAttribute(
          'aria-busy',
          String(isLoading)
        );


        const status =
          box.querySelector(
            '[data-buyer-guide-specs-status]'
          );


        if (
          status
        ) {

          status.textContent =
            message;

        }

      }
    );


    const globalStatus =
      section.querySelector(
        '[data-buyer-guide-global-status]'
      );


    if (
      globalStatus
    ) {

      globalStatus.textContent =
        message;

    }


    updateViewResultsCount();


    if (
      !isLoading &&
      message === updatedFiltersText
    ) {

      successMessageTimer =
        window.setTimeout(
          () => {

            section
              .querySelectorAll(
                '[data-buyer-guide-specs-status], [data-buyer-guide-global-status]'
              )
              .forEach(
                (status) => {

                  if (
                    status.textContent ===
                    updatedFiltersText
                  ) {

                    status.textContent =
                      '';

                  }

                }
              );

          },
          1500
        );

    }

  }



  /*
  ============================================================
  PRESERVE SPEC VALUES WHILE AVAILABILITY UPDATES
  ============================================================
  */

  function getCurrentSpecSelections() {

    const selections =
      new Map();


    section
      .querySelectorAll(
        '[data-buyer-guide-specs-grid] [data-filter-param]'
      )
      .forEach(
        (field) => {

          const param =
            field.getAttribute(
              'data-filter-param'
            );


          if (
            param &&
            field.value
          ) {

            selections.set(
              param,
              field.value
            );

          }

        }
      );


    return selections;

  }



  function restoreValidSpecSelections(
    selections
  ) {

    section
      .querySelectorAll(
        '[data-buyer-guide-specs-grid] [data-filter-param]'
      )
      .forEach(
        (field) => {

          const param =
            field.getAttribute(
              'data-filter-param'
            );


          const previousValue =
            selections.get(
              param
            );


          if (
            !param ||
            !previousValue
          ) {
            return;
          }


          if (
            field.matches(
              'select'
            )
          ) {

            const matchingOption =
              Array.from(
                field.options
              ).find(
                (option) =>
                  option.value ===
                  previousValue
              );


            if (
              matchingOption &&
              !matchingOption.disabled
            ) {

              field.value =
                previousValue;

            } else {

              field.value =
                '';

            }

          } else {

            field.value =
              previousValue;

          }

        }
      );

  }



  /*
  ============================================================
  UPDATE BUYER GUIDE FROM FILTERED PAGE
  ============================================================
  */

  function updateBuyerGuideFromFreshPage(
    freshDocument,
    previousSelections,
    targetUrl
  ) {

    const sectionId =
      section.dataset.sectionId;

    const freshSection =
      freshDocument.getElementById(
        `BuyerGuide-${sectionId}`
      ) ||
      freshDocument.querySelector(
        '[data-buyer-guide-root]'
      );


    if (
      !freshSection
    ) {

      throw new Error(
        'Updated Buyer Guide section was not returned.'
      );

    }


    const currentProductTypeRegion =
      section.querySelector(
        '[data-buyer-guide-product-type-region]'
      );


    const freshProductTypeRegion =
      freshSection.querySelector(
        '[data-buyer-guide-product-type-region]'
      );


    const currentProductTypeMode =
      currentProductTypeRegion
        ?.querySelector(
          '[data-product-type-mode]'
        )
        ?.dataset.productTypeMode ||
      '';


    const freshProductTypeMode =
      freshProductTypeRegion
        ?.querySelector(
          '[data-product-type-mode]'
        )
        ?.dataset.productTypeMode ||
      '';


    if (
      currentProductTypeRegion &&
      freshProductTypeRegion &&
      currentProductTypeMode ===
        freshProductTypeMode
    ) {

      currentProductTypeRegion.innerHTML =
        freshProductTypeRegion.innerHTML;


      restoreProductTypeFromUrl(
        targetUrl.search
      );

    }


    const freshGrids =
      Array.from(
        freshSection.querySelectorAll(
          '[data-buyer-guide-specs-grid]'
        )
      );


    const currentGrids =
      Array.from(
        section.querySelectorAll(
          '[data-buyer-guide-specs-grid]'
        )
      );


    if (
      freshGrids.length > 0 &&
      freshGrids.length ===
      currentGrids.length
    ) {

      currentGrids.forEach(
        (grid, index) => {

          grid.innerHTML =
            freshGrids[index].innerHTML;

        }
      );


      restoreValidSpecSelections(
        previousSelections
      );

    }


    section.dataset.productCount =
      freshSection.dataset.productCount ||
      '';


    applyProductTypeContingencies();


    updateActiveFilterChips();


    updateViewResultsCount();

  }



  /*
  ============================================================
  SHARK PRODUCT GRID UPDATE
  ============================================================
  */

  function updateSharkProducts(
    freshDocument
  ) {

    const currentProducts =
      document.querySelector(
        '[data-products-container]'
      );


    const freshProducts =
      freshDocument.querySelector(
        '[data-products-container]'
      );


    if (
      !currentProducts ||
      !freshProducts
    ) {

      console.warn(
        'Buyer Guide: Shark product container could not be found.'
      );


      return false;

    }


    currentProducts.innerHTML =
      freshProducts.innerHTML;



    /*
    ----------------------------------------------------------
    QUICK VIEW
    ----------------------------------------------------------
    */

    if (
      typeof window.initQuickView ===
      'function'
    ) {

      const quickviewElements =
        currentProducts.querySelectorAll(
          '[data-quickview-action]'
        );


      Array.from(
        quickviewElements
      ).forEach(
        (element) => {

          window.initQuickView(
            element
          );

        }
      );

    }



    /*
    ----------------------------------------------------------
    PRODUCT COLOR SWATCHES
    ----------------------------------------------------------
    */

    if (
      typeof window.colorSwatchesMediaChanged ===
      'function'
    ) {

      window.colorSwatchesMediaChanged(
        currentProducts
      );

    }


    return true;

  }



  /*
  ============================================================
  SHARK SORTING CONTENT
  ============================================================
  */

  function updateSharkSorting(
    freshDocument
  ) {

    const currentSorting =
      document.querySelector(
        '[data-sorting-content]'
      );


    const freshSorting =
      freshDocument.querySelector(
        '[data-sorting-content]'
      );


    if (
      currentSorting &&
      freshSorting
    ) {

      currentSorting.innerHTML =
        freshSorting.innerHTML;


      if (
        typeof window.sortByOptions ===
        'function'
      ) {

        window.sortByOptions();

      }

    }



    const currentSortHidden =
      document.querySelector(
        '.hidden_sort_by'
      );


    const freshSortSelected =
      freshDocument.querySelector(
        '.sort-by-selected'
      );


    if (
      currentSortHidden &&
      freshSortSelected
    ) {

      currentSortHidden.value =
        freshSortSelected.value;

    }

  }



  /*
  ============================================================
  SHARK RESULT COUNT
  ============================================================
  */

  function updateSharkResultCount(
    freshDocument
  ) {

    const currentCount =
      document.querySelector(
        '[data-search-result-count]'
      );


    const freshCount =
      freshDocument.querySelector(
        '[data-search-result-count]'
      );


    if (
      currentCount &&
      freshCount
    ) {

      currentCount.textContent =
        freshCount.textContent;

    }

  }



  /*
  ============================================================
  SHARK NATIVE FILTER SIDEBAR

  Mirrors the relevant portion of Shark filter.js.
  ============================================================
  */

  function getSharkFilterKey(
    filterItem
  ) {

    const fieldNames =
      Array.from(
        filterItem.querySelectorAll(
          'input[name^="filter."], select[name^="filter."]'
        )
      )
        .map(
          (field) =>
            field.name
        )
        .filter(Boolean)
        .sort();


    if (
      fieldNames.length > 0
    ) {

      return fieldNames.join('|');

    }


    const filterParam =
      filterItem
        .querySelector(
          '[data-filter-param]'
        )
        ?.getAttribute(
          'data-filter-param'
        );


    if (
      filterParam
    ) {

      return filterParam;

    }


    const heading =
      filterItem.querySelector(
        '.filter-option-name, .filter-item-title, summary'
      );


    return heading
      ? normalizeHandle(
          heading.textContent
        )
      : '';

  }

  function updateSharkNativeFilters(
    freshDocument
  ) {

    const currentFilterItems =
      document.querySelectorAll(
        '.filter-item'
      );


    const freshFilterItems =
      freshDocument.querySelectorAll(
        '.filter-item'
      );


    if (
      !currentFilterItems.length ||
      !freshFilterItems.length
    ) {
      return;
    }


    const currentItemsByKey =
      new Map(
        Array.from(
          currentFilterItems
        )
          .map(
            (filterItem) => [
              getSharkFilterKey(
                filterItem
              ),
              filterItem
            ]
          )
          .filter(
            ([key]) =>
              Boolean(key)
          )
      );


    Array.from(
      freshFilterItems
    ).forEach(
      (freshFilterItem) => {

        const filterKey =
          getSharkFilterKey(
            freshFilterItem
          );


        const currentFilterItem =
          currentItemsByKey.get(
            filterKey
          );


        if (
          !currentFilterItem
        ) {
          return;
        }



        /*
        ------------------------------------------------------
        PRICE FILTER
        ------------------------------------------------------
        */

        if (
          currentFilterItem.querySelector(
            '.price-slider-range-min'
          )
        ) {

          const currentRange =
            currentFilterItem.querySelector(
              '.filter-option-range-input'
            );


          const freshRange =
            freshFilterItem.querySelector(
              '.filter-option-range-input'
            );


          const currentPriceInputs =
            currentFilterItem.querySelector(
              '.filter-option-price-input'
            );


          const freshPriceInputs =
            freshFilterItem.querySelector(
              '.filter-option-price-input'
            );


          const currentSlider =
            currentFilterItem.querySelector(
              '.filter-option-price-slider'
            );


          const freshSlider =
            freshFilterItem.querySelector(
              '.filter-option-price-slider'
            );


          if (
            currentRange &&
            freshRange
          ) {

            currentRange.innerHTML =
              freshRange.innerHTML;

          }


          if (
            currentPriceInputs &&
            freshPriceInputs
          ) {

            currentPriceInputs.innerHTML =
              freshPriceInputs.innerHTML;

          }


          if (
            currentSlider &&
            freshSlider
          ) {

            currentSlider.innerHTML =
              freshSlider.innerHTML;

          }

        }


        /*
        ------------------------------------------------------
        STANDARD FILTER
        ------------------------------------------------------
        */

        else {

          const currentList =
            currentFilterItem.querySelector(
              '.filter-option-list'
            );


          const freshList =
            freshFilterItem.querySelector(
              '.filter-option-list'
            );


          if (
            currentList &&
            freshList
          ) {

            currentList.innerHTML =
              freshList.innerHTML;

          }

        }

      }
    );

  }



  /*
  ============================================================
  REINITIALIZE SHARK JS AFTER HTML REPLACEMENT
  ============================================================
  */

  function reinitializeSharkCollection() {

    if (
      typeof window.removeFilter ===
      'function'
    ) {

      window.removeFilter();

    }


    if (
      typeof window.applyFilters ===
      'function'
    ) {

      window.applyFilters(
        'updated'
      );

    }


    if (
      typeof window.customDropdownElements ===
      'function'
    ) {

      window.customDropdownElements();

    }


    if (
      typeof window.showMoreFilters ===
      'function'
    ) {

      window.showMoreFilters();

    }


    if (
      typeof window.sideDrawerInt ===
      'function'
    ) {

      window.sideDrawerInt();

    }


    if (
      typeof window.loadMoreCollection ===
      'function'
    ) {

      window.loadMoreCollection();

    }


    if (
      typeof window.productCardHoverInit ===
      'function'
    ) {

      window.productCardHoverInit();

    }



    /*
    ----------------------------------------------------------
    AOS
    ----------------------------------------------------------
    */

    if (
      typeof window.animationStatus !==
        'undefined' &&
      window.animationStatus &&
      typeof window.AOS !==
        'undefined' &&
      window.AOS &&
      typeof window.AOS.refreshHard ===
        'function'
    ) {

      window.AOS.refreshHard();

    }

  }



  /*
  ============================================================
  UPDATE URL WITHOUT ADDING A HISTORY ENTRY FOR EACH CHOICE
  ============================================================
  */

  function updateBrowserUrl(
    targetUrl
  ) {

    const relativeUrl =
      `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`;


    window.history.replaceState(
      {
        buyerGuideFilters: true
      },
      '',
      relativeUrl
    );

  }



  /*
  ============================================================
  FILTERED HTML REQUEST

  Prefer Shopify's Section Rendering API so each selection
  only downloads the Buyer Guide and collection sections.
  Fall back to the complete page if the Shark section wrapper
  cannot be resolved or the target template differs.
  ============================================================
  */

  function getShopifySectionId(
    element
  ) {

    const wrapper =
      element?.closest(
        '[id^="shopify-section-"]'
      );


    return wrapper
      ? wrapper.id.replace(
          'shopify-section-',
          ''
        )
      : '';

  }


  async function fetchHtmlDocument(
    url,
    signal
  ) {

    const response =
      await fetch(
        url.toString(),
        {
          method: 'GET',
          headers: {
            'X-Requested-With':
              'XMLHttpRequest'
          },
          signal
        }
      );


    if (
      !response.ok
    ) {

      throw new Error(
        `Buyer Guide filter request failed with status ${response.status}`
      );

    }


    const html =
      await response.text();


    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      );

  }


  async function fetchFilteredDocument(
    targetUrl,
    signal
  ) {

    const guideSectionId =
      section.dataset.sectionId ||
      getShopifySectionId(section);


    const productContainer =
      document.querySelector(
        '[data-products-container]'
      );


    const collectionSectionId =
      getShopifySectionId(
        productContainer
      );


    const sidebarFilterItem =
      document.querySelector(
        '.filter-item'
      );


    const sidebarSectionId =
      getShopifySectionId(
        sidebarFilterItem
      );


    /*
      If the Shark sidebar exists but isn't inside a Shopify
      section, the Section Rendering API can't return it, so
      fetch the full page instead to keep the sidebar in sync.
    */

    if (
      sidebarFilterItem &&
      !sidebarSectionId
    ) {

      return fetchHtmlDocument(
        targetUrl,
        signal
      );

    }


    const sectionIds =
      Array.from(
        new Set(
          [
            guideSectionId,
            collectionSectionId,
            sidebarSectionId
          ].filter(Boolean)
        )
      );


    if (
      sectionIds.length > 0
    ) {

      const sectionUrl =
        new URL(
          targetUrl.toString()
        );


      sectionUrl.searchParams.set(
        'sections',
        sectionIds.join(',')
      );


      const response =
        await fetch(
          sectionUrl.toString(),
          {
            method: 'GET',
            headers: {
              'X-Requested-With':
                'XMLHttpRequest',
              'Accept':
                'application/json'
            },
            signal
          }
        );


      if (
        response.ok
      ) {

        const renderedSections =
          await response.json();


        const requestedSectionsReturned =
          sectionIds.every(
            (sectionId) =>
              typeof renderedSections[sectionId] ===
                'string'
          );


        if (
          requestedSectionsReturned
        ) {

          const sectionHtml =
            sectionIds
              .map(
                (sectionId) =>
                  renderedSections[sectionId]
              )
              .join('');


          const renderedDocument =
            new DOMParser()
              .parseFromString(
                `<html><body>${sectionHtml}</body></html>`,
                'text/html'
              );


          if (
            (
              renderedDocument.getElementById(
                `BuyerGuide-${guideSectionId}`
              ) ||
              renderedDocument.querySelector(
                '[data-buyer-guide-root]'
              )
            ) &&
            renderedDocument.querySelector(
              '[data-products-container]'
            )
          ) {

            return renderedDocument;

          }

        }

      }

    }


    return fetchHtmlDocument(
      targetUrl,
      signal
    );

  }



  /*
  ============================================================
  LIVE BUYER GUIDE + SHARK COLLECTION AJAX REFRESH
  ============================================================
  */

  async function refreshGuideAndProducts(
    options = {}
  ) {

    if (
      !filterForm
    ) {
      return;
    }


    if (
      refreshController
    ) {

      refreshController.abort();

    }


    refreshController =
      new AbortController();


    const previousSelections =
      getCurrentSpecSelections();


    const targetUrl =
      buildFilteredUrl(
        options
      );


    setLoading(
      true,
      updatingFiltersText
    );


    try {

      const freshDocument =
        await fetchFilteredDocument(
          targetUrl,
          refreshController.signal
        );



      /*
      --------------------------------------------------------
      1. BUYER GUIDE FILTER AVAILABILITY
      --------------------------------------------------------
      */

      updateBuyerGuideFromFreshPage(
        freshDocument,
        previousSelections,
        targetUrl
      );



      /*
      --------------------------------------------------------
      2. PRODUCT CARDS
      --------------------------------------------------------
      */

      const productsUpdated =
        updateSharkProducts(
          freshDocument
        );



      /*
      --------------------------------------------------------
      3. NATIVE SHARK FILTERS
      --------------------------------------------------------
      */

      updateSharkNativeFilters(
        freshDocument
      );



      /*
      --------------------------------------------------------
      4. SORTING
      --------------------------------------------------------
      */

      updateSharkSorting(
        freshDocument
      );



      /*
      --------------------------------------------------------
      5. RESULT COUNT
      --------------------------------------------------------
      */

      updateSharkResultCount(
        freshDocument
      );



      /*
      --------------------------------------------------------
      6. REINITIALIZE THEME JS
      --------------------------------------------------------
      */

      reinitializeSharkCollection();



      /*
      --------------------------------------------------------
      7. UPDATE URL
      --------------------------------------------------------
      */

      updateBrowserUrl(
        targetUrl
      );



      /*
      --------------------------------------------------------
      8. OPTIONAL CUSTOM EVENT
      --------------------------------------------------------
      */

      document.dispatchEvent(
        new CustomEvent(
          'buyer-guide:products-updated',
          {
            detail: {
              url:
                targetUrl.toString(),

              productCount:
                section.dataset.productCount,

              productsUpdated:
                productsUpdated
            }
          }
        )
      );


      setLoading(
        false,
        updatedFiltersText
      );

    }


    catch (
      error
    ) {

      if (
        error.name ===
        'AbortError'
      ) {
        return;
      }


      console.error(
        'Buyer Guide AJAX refresh error:',
        error
      );


      restoreBuyerGuideFieldsFromUrl();


      applyProductTypeContingencies();


      updateActiveFilterChips();


      updateViewResultsCount();


      setLoading(
        false,
        filterUpdateErrorText
      );

    }

  }



  /*
  ============================================================
  DEBOUNCED REFRESH
  ============================================================
  */

  function scheduleRefresh(
    delay = refreshDelay,
    options = {}
  ) {

    if (
      refreshTimer
    ) {

      window.clearTimeout(
        refreshTimer
      );

    }


    refreshTimer =
      window.setTimeout(
        () => refreshGuideAndProducts(
          options
        ),
        Math.max(
          0,
          Number(delay) ||
          0
        )
      );

  }



  /*
  ============================================================
  SCROLL TO SHARK PRODUCT GRID
  ============================================================
  */

  function scrollToProductGrid() {

    const productGrid =
      document.querySelector(
        '[data-products-container]'
      );


    if (
      !productGrid
    ) {
      return;
    }


    productGrid.scrollIntoView(
      {
        behavior:
          'smooth',

        block:
          'start'
      }
    );

  }



  /*
  ============================================================
  INITIAL STATE
  ============================================================
  */

  restoreProductTypeFromUrl();


  applyProductTypeContingencies();


  updateActiveFilterChips();


  updateViewResultsCount();



  /*
  ============================================================
  SELECT / RADIO CHANGE
  ============================================================
  */

  filterForm.addEventListener(
    'change',
    (event) => {

      const field =
        event.target.closest(
          '[data-filter-param]'
        );


      if (
        !field ||
        !filterForm.contains(
          field
        )
      ) {
        return;
      }



      /*
      --------------------------------------------------------
      PRODUCT TYPE
      --------------------------------------------------------
      */

      if (
        field.matches(
          '[data-product-type-option]'
        )
      ) {

        if (
          !field.checked
        ) {
          return;
        }


        /*
          Keep current HSM behaviour:
          when switching between major stick types, clear
          spec selections because each type can have a very
          different valid specification universe.
        */

        clearSpecSelections();


        applyProductTypeContingencies();


        openSpecsCard();


        updateActiveFilterChips();


        scheduleRefresh(
          0
        );


        return;

      }



      /*
      --------------------------------------------------------
      SPECS
      --------------------------------------------------------
      */

      updateActiveFilterChips();


      scheduleRefresh();

    }
  );



  /*
  ============================================================
  PRICE INPUT

  Slightly longer delay prevents a request on each keystroke.
  ============================================================
  */

  filterForm.addEventListener(
    'input',
    (event) => {

      const field =
        event.target.closest(
          'input[type="number"][data-filter-param]'
        );


      if (
        !field
      ) {
        return;
      }


      updateActiveFilterChips();


      scheduleRefresh(
        Math.max(
          500,
          Number(refreshDelay) ||
          0
        )
      );

    }
  );



  /*
  ============================================================
  PREVENT STANDARD FORM SUBMISSION
  ============================================================
  */

  filterForm.addEventListener(
    'submit',
    (event) => {

      event.preventDefault();


      if (
        !isRefreshing
      ) {

        scrollToProductGrid();

      }

    }
  );



  /*
  ============================================================
  VIEW MATCHING STICKS

  Filtering has already happened.
  This CTA only scrolls to the results.
  ============================================================
  */

  if (
    viewResultsButton
  ) {

    viewResultsButton.addEventListener(
      'click',
      () => {

        if (
          isRefreshing
        ) {
          return;
        }


        scrollToProductGrid();

      }
    );

  }



  /*
  ============================================================
  CLEAR ALL BUYER GUIDE SELECTIONS
  ============================================================
  */

  if (
    clearAllButton
  ) {

    clearAllButton.addEventListener(
      'click',
      () => {

        const fields =
          Array.from(
            filterForm.querySelectorAll(
              '[data-filter-param]'
            )
          );


        fields.forEach(
          (field) => {

            if (
              field.type === 'checkbox' ||
              field.type === 'radio'
            ) {

              field.checked =
                false;

            } else {

              field.value =
                '';

            }

          }
        );


        const anyTypeOption =
          getProductTypeOptions().find(
            (option) =>
              option.value === ''
          );


        if (
          anyTypeOption
        ) {

          anyTypeOption.checked =
            true;

        }


        applyProductTypeContingencies();


        updateActiveFilterChips();


        scheduleRefresh(
          0
        );

      }
    );

  }



  /*
  ============================================================
  REMOVE INDIVIDUAL ACTIVE CHIP
  ============================================================
  */

  if (
    activeChipList
  ) {

    activeChipList.addEventListener(
      'click',
      (event) => {

        const chip =
          event.target.closest(
            '[data-remove-filter-param]'
          );


        if (
          !chip
        ) {
          return;
        }


        const filterParam =
          chip.dataset.removeFilterParam;


        const matchingFields =
          Array.from(
            filterForm.querySelectorAll(
              '[data-filter-param]'
            )
          ).filter(
            (field) =>
              field.getAttribute(
                'data-filter-param'
              ) ===
              filterParam
          );


        if (
          filterParam ===
          'filter.p.product_type'
        ) {

          matchingFields.forEach(
            (field) => {

              field.checked =
                field.value === '';

            }
          );


          clearSpecSelections();

        }

        else {

          matchingFields.forEach(
            (field) => {

              if (
                field.type === 'checkbox' ||
                field.type === 'radio'
              ) {

                field.checked =
                  false;

              } else {

                field.value =
                  '';

              }

            }
          );

        }


        applyProductTypeContingencies();


        updateActiveFilterChips();


        scheduleRefresh(
          0
        );

      }
    );

  }



  /*
  ============================================================
  NORMALIZE INITIAL RESULTS

  This applies the always-on availability filter and removes
  stale contingency filters (for example Brand on Blackout or
  Grip on Retail) without requiring a shopper interaction.
  ============================================================
  */

  function urlNeedsNormalization() {

    const normalizedUrl =
      buildFilteredUrl({
        keepPage: true
      });

    const normalizedParams =
      new URLSearchParams(
        normalizedUrl.search
      );

    const currentParams =
      new URLSearchParams(
        window.location.search
      );

    normalizedParams.delete('page');
    currentParams.delete('page');

    normalizedParams.sort();
    currentParams.sort();

    return (
      normalizedUrl.pathname !==
        window.location.pathname ||
      normalizedParams.toString() !==
        currentParams.toString()
    );

  }


  let lastNormalizedFrom =
    '';

  let normalizeCheckTimer =
    null;


  function checkNormalization() {

    if (
      isRefreshing ||
      !urlNeedsNormalization()
    ) {
      return;
    }


    /*
      Loop guard: never auto-normalize the same URL twice
      in a row.
    */

    const currentUrl =
      `${window.location.pathname}${window.location.search}`;

    if (
      currentUrl ===
      lastNormalizedFrom
    ) {
      return;
    }

    lastNormalizedFrom =
      currentUrl;


    scheduleRefresh(
      0,
      {
        keepPage: true
      }
    );

  }


  /*
    Debounced so Shark can finish both its URL change and its
    product grid swap before the guide re-applies filters.
  */

  function queueNormalizationCheck() {

    if (
      normalizeCheckTimer
    ) {

      window.clearTimeout(
        normalizeCheckTimer
      );

    }

    normalizeCheckTimer =
      window.setTimeout(
        checkNormalization,
        300
      );

  }


    /*
  ============================================================
  ADD BUYER GUIDE FILTERS TO SHARK REQUESTS

  When Shark sorts, paginates, or refreshes the grid, it builds
  its URL without the Buyer Guide's filters. This adds them to
  Shark's request before it is sent, so results load filtered
  the first time (no second refresh needed).

  Shark's own params (sort_by, page, etc.) are left untouched.
  ============================================================
  */

  function mergeGuideFiltersIntoUrl(
    rawUrl
  ) {

    let url;

    try {

      url =
        new URL(
          rawUrl,
          window.location.href
        );

    } catch (error) {

      return rawUrl;

    }


    // Only touch requests for this same collection page.
    if (
      url.origin !==
        window.location.origin ||
      url.pathname !==
        buildFilteredUrl().pathname
    ) {
      return rawUrl;
    }


    const guideParams =
      new URLSearchParams();

    appendCurrentBuyerGuideFilters(
      guideParams
    );


    guideParams.forEach(
      (value, key) => {

        url.searchParams.set(
          key,
          value
        );

      }
    );


    return `${url.pathname}${url.search}${url.hash}`;

  }


  window.__buyerGuideUrlMergers =
    window.__buyerGuideUrlMergers || [];

  window.__buyerGuideUrlMergers.push({
    section,
    merge: mergeGuideFiltersIntoUrl
  });


  if (
    !window.__buyerGuideRequestsPatched
  ) {

    window.__buyerGuideRequestsPatched =
      true;


    const applyMergers =
      (rawUrl) =>
        (window.__buyerGuideUrlMergers || [])
          .filter(
            (entry) =>
              entry.section.isConnected
          )
          .reduce(
            (currentUrl, entry) =>
              entry.merge(currentUrl),
            rawUrl
          );


    /*
    ----------------------------------------------------------
    fetch()
    ----------------------------------------------------------
    */

    const originalFetch =
      window.fetch;

    window.fetch =
      function (input, init) {

        try {

          const method =
            (init && init.method) ||
            (input instanceof Request ? input.method : 'GET');

          if (
            String(method).toUpperCase() === 'GET'
          ) {

            if (
              typeof input === 'string' ||
              input instanceof URL
            ) {

              input =
                applyMergers(
                  String(input)
                );

            } else if (
              input instanceof Request
            ) {

              const mergedUrl =
                applyMergers(
                  input.url
                );

              if (
                mergedUrl !== input.url
              ) {

                input =
                  new Request(
                    mergedUrl,
                    input
                  );

              }

            }

          }

        } catch (error) {}

        return originalFetch.call(
          this,
          input,
          init
        );

      };


    /*
    ----------------------------------------------------------
    jQuery / XMLHttpRequest
    ----------------------------------------------------------
    */

    const originalOpen =
      XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open =
      function (method, url, ...rest) {

        try {

          if (
            url &&
            String(method).toUpperCase() === 'GET'
          ) {

            url =
              applyMergers(
                String(url)
              );

          }

        } catch (error) {}

        return originalOpen.call(
          this,
          method,
          url,
          ...rest
        );

      };


    /*
    ----------------------------------------------------------
    Address bar updates (pushState / replaceState)
    ----------------------------------------------------------
    */

    ['pushState', 'replaceState'].forEach(
      (method) => {

        const original =
          window.history[method];

        window.history[method] =
          function (state, title, url) {

            const isGuideUpdate =
              state &&
              state.buyerGuideFilters;

            if (
              url &&
              !isGuideUpdate
            ) {

              try {

                url =
                  applyMergers(
                    String(url)
                  );

              } catch (error) {}

            }

            const result =
              original.call(
                this,
                state,
                title,
                url
              );

            document.dispatchEvent(
              new CustomEvent(
                'buyer-guide:history-change',
                {
                  detail: {
                    state
                  }
                }
              )
            );

            return result;

          };

      }
    );


    /*
    ----------------------------------------------------------
    Pagination / collection links (full page loads)
    ----------------------------------------------------------
    */

    document.addEventListener(
      'click',
      (event) => {

        const link =
          event.target.closest &&
          event.target.closest('a[href]');

        if (
          !link
        ) {
          return;
        }

        const href =
          link.getAttribute('href');

        if (
          !href ||
          href.startsWith('#') ||
          href.startsWith('javascript:')
        ) {
          return;
        }

        try {

          const mergedHref =
            applyMergers(
              href
            );

          if (
            mergedHref !== href
          ) {

            link.setAttribute(
              'href',
              mergedHref
            );

          }

        } catch (error) {}

      },
      true
    );

  }


  document.addEventListener(
    'buyer-guide:history-change',
    (event) => {

      // Ignore the Buyer Guide's own URL updates.
      if (
        event.detail?.state?.buyerGuideFilters
      ) {
        return;
      }

      queueNormalizationCheck();

    }
  );


  window.addEventListener(
    'popstate',
    queueNormalizationCheck
  );


  const productsContainerToWatch =
    document.querySelector(
      '[data-products-container]'
    );

  if (
    productsContainerToWatch
  ) {

    new MutationObserver(
      queueNormalizationCheck
    ).observe(
      productsContainerToWatch,
      {
        childList: true
      }
    );

  }


  // Initial check on page load
  if (
    urlNeedsNormalization()
  ) {

    lastNormalizedFrom =
      `${window.location.pathname}${window.location.search}`;

    scheduleRefresh(
      0,
      {
        keepPage: true
      }
    );

  }

  }


  function initializeBuyerGuides(
    root = document
  ) {

    const buyerGuides =
      [];


    if (
      root.matches &&
      root.matches(
        '[data-buyer-guide-root]'
      )
    ) {

      buyerGuides.push(
        root
      );

    }


    if (
      root.querySelectorAll
    ) {

      root
        .querySelectorAll(
          '[data-buyer-guide-root]'
        )
        .forEach(
          (buyerGuide) => {

            if (
              !buyerGuides.includes(
                buyerGuide
              )
            ) {

              buyerGuides.push(
                buyerGuide
              );

            }

          }
        );

    }


    buyerGuides.forEach(
      initBuyerGuide
    );

  }


  const initialize =
    () => initializeBuyerGuides(
      document
    );


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );

  } else {

    initialize();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initializeBuyerGuides(
        event.target
      );

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
